import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Checkbox } from '@carsys/form'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { OrderSystemService } from '@cbgms/api/modules/enums'
import { FormValues } from './Form'

const spacing = 1
const dividerStyle = { marginY: 2 }

export const StockSettings: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { values: formValues } = useFormikContext<FormValues>()

  return (
    <Box>
      {formValues.ServiceToggles[OrderSystemService.PriceStock] && (
        <>
          <Divider variant='middle' sx={dividerStyle} />
          <Stack spacing={spacing}>
            <Typography variant='h6'>{t('wholesale.stock_settings')}</Typography>
            <Box sx={{ display: 'flex' }}>
              <Checkbox name='HideLocalStock' label={t('wholesale.HideLocalStock')} title={t('wholesale.HideLocalStock_info_title')} />
              <Checkbox name='HideTotalStock' label={t('wholesale.HideTotalStock')} title={t('wholesale.HideTotalStock_info_title')} />
            </Box>
          </Stack>
        </>
      )}
    </Box>
  )
}

export default StockSettings
